import { CSSProperties, useMemo } from 'react';
import { CandleValidation } from 'client/voladeum/candle-validations/types';
import { useGridColumnContext } from 'framework/Grid/context/GridColumnContext';
import { useGridRowContext } from 'framework/Grid/context/GridRowContext';
import { colors } from 'framework/theme/constants/colors';

import cn from './Cell.module.scss';

export const GridDaysCell = () => {
  const { row } = useGridRowContext<CandleValidation>();
  const { column } = useGridColumnContext();

  const color = useMemo((): CSSProperties['color'] => {
    if (row.day_percent < 1) {
      return colors.red[9];
    }
    return colors.light[1];
  }, [row]);

  return (
    <div className={cn.cell} style={{ justifyContent: column.text_align }}>
      <span style={{ color }}>
        {row.day_count_formatted} ({row.day_percent_formatted})
      </span>
    </div>
  );
};
